function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import './DateInput.css';
import cs from 'classnames';
import en from './locales/DateInput.en.json';
import compose from '../../utils/compose';
import { default as withInputAriaAttributes } from '../../withInputAriaAttributes/withInputAriaAttributes';
import { default as withInputClasses } from '../../withInputClasses/withInputClasses';
import { default as withInputContainer } from '../withInputContainer/withInputContainer';
import { default as withInputStyles } from '../../withInputStyles/withInputStyles';
import { injectIntl } from 'react-intl';
import noop from '../../utils/noop';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import whitelistProps from '../../utils/whitelistProps';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import ThemeContext from '../../ThemeContext';
import { useContext } from 'react';
var MESSAGE_PREFIX = '@dm/components.date-input';
var messages = normalizeLocaleData(en, MESSAGE_PREFIX);
var messageId = function messageId(id) {
  return "".concat(MESSAGE_PREFIX, ".").concat(id);
};
var getMessage = function getMessage(intl, id) {
  return intl.messages[messageId(id)];
};
function supports(type) {
  var modernizr = window.Modernizr || {
    inputtypes: {}
  };
  return modernizr.inputtypes[type];
}
var whitelist = whitelistProps('className', 'disabled', 'name', 'onBlur', 'onFocus', 'readonly', 'required', 'value');
var inferYear = function inferYear(isoDate) {
  if (!isoDate && isoDate.length !== 10) {
    return undefined;
  }
  var provided = parseInt(isoDate.substring(0, 4), 10);
  var year = provided;
  if (provided < 50) {
    year = 2000 + provided;
  } else if (provided < 100) {
    year = 1900 + provided;
  }
  return year === provided ? isoDate : year + isoDate.substring(4);
};
var NativeDateInput = /*#__PURE__*/function (_React$Component) {
  _inherits(NativeDateInput, _React$Component);
  function NativeDateInput(props) {
    var _this;
    _classCallCheck(this, NativeDateInput);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(NativeDateInput).call(this, props));
    _this.handleBlur = function (e) {
      var value = e.target.value;
      var inferred = inferYear(value);
      if (inferred !== value) {
        _this.props.onChange(e, inferred);
        setTimeout(function () {
          return _this.doBlur({
            target: {
              value: value
            }
          });
        }, 10);
      } else {
        _this.doBlur(e);
      }
    };
    _this.doBlur = function (e) {
      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
      // need to clear out input with invalid date (ex. 2/31/2020)
      var input = _this.inputRef.current;
      if (input && !_this.props.value) {
        input.value = undefined; // PRO-11111 Safari only clears on undefined; chrome seems to do both null/undefined
      }
    };
    _this.handleChange = function (e) {
      _this.props.onChange(e, e.target.value);
    };
    _this.inputRef = React.createRef();
    return _this;
  }
  _createClass(NativeDateInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$max = _this$props.max,
        max = _this$props$max === void 0 ? '' : _this$props$max,
        _this$props$min = _this$props.min,
        min = _this$props$min === void 0 ? '' : _this$props$min,
        readonly = _this$props.readonly,
        attrs = _objectWithoutProperties(_this$props, ["max", "min", "readonly"]);
      return /*#__PURE__*/React.createElement("input", Object.assign({
        onChange: this.handleChange,
        ref: this.inputRef,
        type: "date",
        readOnly: readonly
      }, whitelist(attrs), {
        max: max,
        min: min,
        onBlur: this.handleBlur
      }));
    }
  }]);
  return NativeDateInput;
}(React.Component);
var FallbackDateInput = /*#__PURE__*/function (_React$Component2) {
  _inherits(FallbackDateInput, _React$Component2);
  function FallbackDateInput(props) {
    var _this2;
    _classCallCheck(this, FallbackDateInput);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(FallbackDateInput).call(this, props));

    /**
     * Existing dates will be in ISO format
     * Need to convert it to mm/dd/yyyy form to display
     * correctly in the input on initial render
     */
    _this2.handleChange = function (e) {
      var rawValue = e.target.value || '';
      _this2.setState({
        rawValue: rawValue
      });
      var changeValue = '';
      if (_this2.testDate(rawValue)) {
        var isoValue = _this2.getISODateString(rawValue);
        changeValue = isoValue ? isoValue : changeValue;
      }
      _this2.props.onChange(e, changeValue);
    };
    _this2.handleBlur = function (e) {
      var value = e.target.value || '';
      var rawValue = _this2.testDate(value) ? _this2.formatDateForTextInput(value) : '';
      _this2.setState({
        rawValue: rawValue
      });
      _this2.props.onBlur(e);
    };
    var _rawValue = props.value ? _this2.formatDateForTextInput(props.value) : '';
    _this2.state = {
      rawValue: _rawValue
    };
    return _this2;
  }
  _createClass(FallbackDateInput, [{
    key: "testDate",
    value: function testDate(rawValue) {
      var regex = new RegExp(getMessage(this.props.intl, 'date-regex'));
      return regex.test(rawValue);
    }
  }, {
    key: "getISODateString",
    value: function getISODateString(rawInputValue) {
      var parsed = Date.parse(rawInputValue);
      if (Number.isNaN(parsed)) {
        return false;
      }
      var date = new Date(parsed);
      if (date.getFullYear() > 9999 || date.getFullYear() < 1000) {
        return false;
      }
      return date.toISOString().split('T')[0];
    }
  }, {
    key: "formatDateForTextInput",
    value: function formatDateForTextInput(rawInputValue) {
      var isoDate = this.getISODateString(rawInputValue);
      if (!isoDate) {
        return '';
      }
      var _isoDate$split = isoDate.split('-'),
        _isoDate$split2 = _slicedToArray(_isoDate$split, 3),
        year = _isoDate$split2[0],
        month = _isoDate$split2[1],
        day = _isoDate$split2[2];
      var format = getMessage(this.props.intl, 'format');
      return format.replace('d', day).replace('m', month).replace('y', year);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        intl = _this$props2.intl,
        readonly = _this$props2.readonly,
        attrs = _objectWithoutProperties(_this$props2, ["intl", "readonly"]);
      return /*#__PURE__*/React.createElement("input", Object.assign({
        onChange: this.handleChange,
        placeholder: getMessage(intl, 'placeholder'),
        pattern: getMessage(intl, 'pattern'),
        readOnly: readonly,
        type: "text"
      }, whitelist(attrs), {
        onBlur: this.handleBlur,
        value: this.state.rawValue
      }));
    }
  }]);
  return FallbackDateInput;
}(React.Component);
var BaseDateInput = function BaseDateInput(props) {
  var theme = useContext(ThemeContext);
  var fallback = props.readonly || !supports('date');
  var Component = fallback ? FallbackDateInput : NativeDateInput;
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    onBlur: props.onBlur || noop,
    onChange: props.onChange || noop,
    className: cs(props.className, "_dm-dateinput--".concat(theme))
  }));
};
var options = {
  metaType: 'text',
  type: 'date'
};
export var DateInput = compose(withAdditionalIntl(messages), injectIntl, withInputStyles, withInputClasses(options), withInputAriaAttributes)(BaseDateInput);
export default withInputContainer(options)(DateInput);